export const MOVEMENT_EVENT_VIEW_CONTEXT = 'movement_show';
export const PETITION_COUNT_PER_ROW = 3;
export const WEEKLY_SIGNATURE_THRESHOLD = 5;
/** Query Params * */
export const QUERY_PARAM_SOURCE_LOCATION = 'source_location';
export const QUERY_PARAM_MOVEMENT = 'movement';
